module.exports = __webpack_public_path__ + "img/project14_1.jpg.5742008a.webp";